import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import * as React from 'react';
import * as styles from './SlidesContainer.css';
import { Slide } from './parts/Slide';
import { Gap } from '../Gap';
import { mergeStyles } from '@cian/utils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var SlidesContainer = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var slideWidth = props.slideWidth,
    gapWidth = props.gapWidth,
    slides = props.slides,
    leftOffset = props.leftOffset,
    handleSlideClick = props.handleSlideClick;
  return /*#__PURE__*/_jsx("div", {
    className: styles['carousel-slides-container'],
    "data-testid": "SlidesContainer",
    children: /*#__PURE__*/_jsx("div", _objectSpread(_objectSpread({}, mergeStyles(styles['carousel-slides-wrapper'])), {}, {
      style: {
        transform: "translateX(".concat(leftOffset, "px)")
      },
      ref: ref,
      children: slides.map(function (slide) {
        return /*#__PURE__*/_jsxs("div", {
          className: styles['slide-wrapper'],
          children: [/*#__PURE__*/_jsx(Gap, {
            width: gapWidth
          }), /*#__PURE__*/_jsx(Slide, {
            width: slideWidth,
            slide: slide.node,
            onClick: handleSlideClick ? function (e) {
              return handleSlideClick(Number(slide.key) - 1, e);
            } : undefined
          })]
        }, slide.key);
      })
    }))
  });
});
SlidesContainer.displayName = 'SlidesContainer';